import { Post, Put, Get, getApiUrl } from '../api'
import {
  UPDATE_LOGGED_IN_USER,
  UPDATE_MFAENABLED,
  REGISTER,
  EMAIL,
  USER_LOGOUT,
  GET_USER_DATA,
  UPDATE_USER_ACTIVATION_LINK,
  VIEW_DEMOGRAPHY,
} from '../types'
import axios from 'axios'
import { startLoading, stopLoading } from './loaderAction'
import {
  RECENT_COMPANIES_STORAGE_KEY,
  clearLocalStorageExcept,
} from 'src/utils/localStorageKeys'
const options = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}

//  const tokenexp =process.env.EXPIRES
export const login =
  (args = {}) =>
  async (dispatch, getState) => {
    // let error
    try {
      dispatch(startLoading())
      const res = await Post(
        // method: 'post',
        `${getApiUrl()}/auth/login`,
        {
          username: args.username,
          password: args.password,
          role: args.role,
          companyId: args.companyId, // Include companyId for multi-tenant support
          forceLogin: args.forceLogin, // Confirms evicting an existing active session
        },
        options,
      )
      if (res.success) {
        dispatch(stopLoading())
        // Check if company selection is required
        if (res?.data?.requiresCompanySelection || res?.data?.data?.requiresCompanySelection) {
          return {
            ...res.data,
            requiresCompanySelection: true,
            companies: res?.data?.data?.companies || res?.data?.companies
          }
        }
        // Backend found an existing active session for this account and is
        // asking whether to log it out and continue here -- don't treat
        // this as a completed login (no UPDATE_LOGGED_IN_USER dispatch).
        if (res?.data?.requiresSessionConfirmation || res?.data?.data?.requiresSessionConfirmation) {
          return {
            ...res.data,
            requiresSessionConfirmation: true,
            message: res?.data?.message,
          }
        }
        dispatch({
          type: UPDATE_LOGGED_IN_USER,
          payload: {
            ...res?.data?.data,
            companyId: res?.data?.data?.companyId,
            token: res?.data?.data?.token,
            type: res?.data?.data?.type,
             findToAccessPermissionMigrationProduct:
              res?.data?.findToAccessPermissionMigrationProduct,
            getPermisionCioms: res?.data?.getPermisionCioms,
            getPermisionMedWatch: res?.data?.getPermisionMedWatch,
            getPermisionGenerateReport: res?.data?.getPermisionGenerateReport,
            getPermisionLinelistingReport: res?.data?.getPermisionLinelistingReport,
            getPermisionCaseExtraction: res?.data?.getPermisionCaseExtraction,
            getPermisionAduitTrails: res?.data?.getPermisionAduitTrails,
            getPermissionDublicateCase: res?.data?.getPermissionDublicateCase,
            getPermissionCaseHistory: res?.data?.getPermissionCaseHistory,
            getPermissionViewReopenCase:
              res?.data?.getPermissionViewReopenCase,
            findAccesToUserRegRep: res?.data?.findAccesToUserRegRep,
            findToAccessPermissionSubmission:
              res?.data?.findToAccessPermissionSubmission,
            findAccesToAccessPerOpenCase:
              res?.data?.findAccesToAccessPerOpenCase,
            findAccesToAccessPermissionProduct:
              res?.data?.findAccesToAccessPermissionProduct,
            findAccesToAccessPermissionStudyManagement:
              res?.data?.findAccesToAccessPermissionStudyManagement,
            findAccesToAccesPermissionLiterature:
              res?.data?.findAccesToAccesPermissionLiterature,
            findAccesToAccesPermissionEmail:
              res?.data?.findAccesToAccesPermissionEmail,

            findAccesToAccessPermissionTemplateManagement:
              res?.data?.findAccesToAccessPermissionTemplateManagement,
            findAccesToAccessPermissionMigration:
              res?.data?.findAccesToAccessPermissionMigration,
            findAccessPermisionSelectMedDra:
              res?.data?.findAccessPermisionSelectMedDra,
            findAccessToFieldMangament: res?.data?.findAccessToFieldMangament,
            dashboardProduct: res?.data?.dashboardProduct,
            dashboardReports: res?.data?.dashboardReports,
            dashboardAuditTrails: res?.data?.dashboardAuditTrails,
            dashboardStudyManagement: res?.data?.dashboardStudyManagement,
            dashboardSubmission: res?.data?.dashboardSubmission,
          },
        })
        return Promise.resolve(res.data.data)
      } else {
        dispatch(stopLoading())
        throw res.error.message
      }

    } catch (err) {
      dispatch(stopLoading())
      return Promise.reject(err)
    }
  }

export const loginWithOTP =
  (args = {}) =>
  async (dispatch, getState) => {
    // let error
    try {
      dispatch(startLoading())
      const res = await Post(
        // method: 'post',
        `${getApiUrl()}/auth/otplogin`,
        {
          userId: args.userId,
          otp: args.otp,
          companyId: args.companyId,
        },
        options,
      )
      if (res.success) {
        dispatch(stopLoading())
        dispatch({
          type: UPDATE_LOGGED_IN_USER,
          payload: {
            ...res?.data?.data,
            companyId: res?.data?.data?.companyId,
            token: res?.data?.data?.token,
            type: res?.data?.data?.type,
             findToAccessPermissionMigrationProduct:
              res?.data?.findToAccessPermissionMigrationProduct,
            getPermisionCioms: res?.data?.data?.getPermisionCioms,
            getPermisionMedWatch: res?.data?.data?.getPermisionMedWatch,
            getPermisionGenerateReport: res?.data?.data?.getPermisionGenerateReport,
            getPermisionLinelistingReport: res?.data?.data?.getPermisionLinelistingReport,
            getPermisionCaseExtraction: res?.data?.data?.getPermisionCaseExtraction,
            getPermisionAduitTrails: res?.data?.data?.getPermisionAduitTrails,
            getPermissionDublicateCase: res?.data?.data?.getPermissionDublicateCase,
            getPermissionCaseHistory: res?.data?.data?.getPermissionCaseHistory,
            getPermissionViewReopenCase:
              res?.data?.data?.getPermissionViewReopenCase,
            findAccesToUserRegRep: res?.data?.data?.findAccesToUserRegRep,
            findToAccessPermissionSubmission:
              res?.data?.data?.findToAccessPermissionSubmission,
            findAccesToAccessPerOpenCase:
              res?.data?.data?.findAccesToAccessPerOpenCase,
            findAccesToAccessPermissionProduct:
              res?.data?.data?.findAccesToAccessPermissionProduct,
            findAccesToAccessPermissionStudyManagement:
              res?.data?.data?.findAccesToAccessPermissionStudyManagement,
            findAccesToAccesPermissionLiterature:
              res?.data?.data?.findAccesToAccesPermissionLiterature,
            findAccesToAccesPermissionEmail:
              res?.data?.data?.findAccesToAccesPermissionEmail,
            findAccesToAccessPermissionTemplateManagement:
              res?.data?.data?.findAccesToAccessPermissionTemplateManagement,
            findAccesToAccessPermissionMigration:
              res?.data?.data?.findAccesToAccessPermissionMigration,
            findAccessPermisionSelectMedDra:
              res?.data?.data?.findAccessPermisionSelectMedDra,
            dashboardProduct: res?.data?.data?.dashboardProduct,
            dashboardReports: res?.data?.data?.dashboardReports,
            dashboardAuditTrails: res?.data?.data?.dashboardAuditTrails,
            dashboardStudyManagement: res?.data?.data?.dashboardStudyManagement,
            dashboardSubmission: res?.data?.data?.dashboardSubmission,
          },
        })
        return res.data
      } else {
        dispatch(stopLoading())
        throw res.error.message
      }
    } catch (err) {
      dispatch(stopLoading())
      return Promise.reject(err)
    }
  }

export const resendLogin =
  (args = {}) =>
  async (dispatch, getState) => {
    // let error
    try {
      dispatch(startLoading())
      const res = await Post(
        // method: 'post',
        `${getApiUrl()}/auth/resendotpLogin`,
        {
          userId: args.userId,
          companyId: args.companyId,
        },
        options,
      )
      if (res.success) {
        dispatch(stopLoading())
        dispatch({
          type: UPDATE_LOGGED_IN_USER,
          payload: {
            ...res?.data?.data,
            companyId: res?.data?.companyId,
            token: res?.data?.token,
            type: res?.data?.type,
             findToAccessPermissionMigrationProduct:
              res?.data?.findToAccessPermissionMigrationProduct,
            getPermisionCioms: res?.data?.getPermisionCioms,
            getPermisionMedWatch: res?.data?.getPermisionMedWatch,
            getPermisionGenerateReport: res?.data?.getPermisionGenerateReport,
            getPermisionLinelistingReport: res?.data?.getPermisionLinelistingReport,
            getPermisionCaseExtraction: res?.data?.getPermisionCaseExtraction,
            getPermisionAduitTrails: res?.data?.getPermisionAduitTrails,
            getPermissionDublicateCase: res?.data?.getPermissionDublicateCase,
            getPermissionCaseHistory: res?.data?.getPermissionCaseHistory,
            getPermissionViewReopenCase:
              res?.data?.getPermissionViewReopenCase,
            findAccesToUserRegRep: res?.data?.findAccesToUserRegRep,
            findToAccessPermissionSubmission:
              res?.data?.findToAccessPermissionSubmission,
            findAccesToAccessPerOpenCase:
              res?.data?.findAccesToAccessPerOpenCase,
            findAccesToAccessPermissionProduct:
              res?.data?.findAccesToAccessPermissionProduct,
            findAccesToAccessPermissionStudyManagement:
              res?.data?.findAccesToAccessPermissionStudyManagement,
            findAccesToAccesPermissionLiterature:
              res?.data?.findAccesToAccesPermissionLiterature,
            findAccesToAccesPermissionEmail:
              res?.data?.findAccesToAccesPermissionEmail,
            findAccesToAccessPermissionTemplateManagement:
              res?.data?.findAccesToAccessPermissionTemplateManagement,
            findAccesToAccessPermissionMigration:
              res?.data?.findAccesToAccessPermissionMigration,
            findAccessPermisionSelectMedDra:
              res?.data?.findAccessPermisionSelectMedDra,
          },
        })
        return res.data
      } else {
        dispatch(stopLoading())
        throw res.error.message
      }
    } catch (err) {
      dispatch(stopLoading())
      return Promise.reject(err)
    }
  }

export const userLogut = (args) => async (dispatch, getState) => {
  try {
    dispatch(startLoading())
    const { user } = getState().authReducer
    // const options = {
    //   headers: {
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json',
    //     Authorization: `Bearer ${user?.token}`,
    //   },
    // }
    args.token = user?.token
    dispatch({ type: USER_LOGOUT })
    const res = await Put(
      // method: 'put',
      `${getApiUrl()}/auth/logout`,
      args,
      user,
      // ...options,
    )
    if (res?.success) {
      dispatch(stopLoading())
      dispatch({
        type: USER_LOGOUT,
        payload: res?.data,
      })
    } else {
      dispatch(stopLoading())
      throw res.error.message
    }
  } catch (err) {
    dispatch(stopLoading())
    return Promise.reject(err)
  } finally {
    // Always terminate the local session -- tokens and tenant/company
    // selection (SELECTED_COMPANY_STORAGE_KEYS in utils/localStorageKeys.js)
    // must be cleared even if the /auth/logout call itself failed (e.g.
    // network error, already-expired token), otherwise a user could stay
    // logged in against the previously selected company client-side.
    clearLocalStorageExcept([RECENT_COMPANIES_STORAGE_KEY])
  }
}

export const RegisterAcount =
  (args = {}) =>
  async (dispatch) => {
    try {
      dispatch(startLoading())
      const res = await Post(
        // method: 'post',
        `${getApiUrl()}/accounts`,
        args,
        ...options,
      )

      if (res?.success) {
        dispatch(stopLoading())
        dispatch({
          type: REGISTER,
          payload: res?.data,
        })
      } else {
        dispatch(stopLoading())
        throw res.error.message
      }
    } catch (err) {
      dispatch(stopLoading())
      return Promise.reject(err)
    }
  }

export const emailProfile =
  (args = {}) =>
  async (dispatch) => {
    try {
      dispatch(startLoading())
      const res = await Post(
        // method: 'post',
        `${getApiUrl()}/accounts/getProfile`,
        {
          email: args.email,
        },
        ...options,
      )

      if (res?.success) {
        dispatch(stopLoading())
        dispatch({
          type: EMAIL,
          payload: res?.data,
        })
      } else {
        dispatch(stopLoading())
        throw res.error.message
      }
    } catch (err) {
      dispatch(stopLoading())
      return Promise.reject(err)
    }
  }

export const getUserDetails = (uuid, companyId) => async (dispatch, getState) => {
  // const { user } = getState().authReducer

  try {
    dispatch(startLoading())
    const res = await axios({
      method: 'get',
      url: `${getApiUrl()}/users/expire/${uuid}${companyId ? `?companyId=${companyId}` : ''}`,
    })
    if (res?.success) {
      dispatch(stopLoading())
      dispatch({
        type: GET_USER_DATA,
        payload: res?.data,
      })
    } else {
      dispatch(stopLoading())
      throw res.error.message
    }
  } catch (err) {
    dispatch(stopLoading())
    return Promise.reject(err)
  }
}

///resend activation link

export const resendActivationLink = (id) => async (dispatch, getState) => {
  const { user } = getState().authReducer
  // const options = {
  //   headers: {
  //     Accept: 'application/json',
  //     'Content-Type': 'application/json',
  //     Authorization: `Bearer ${user?.token}`,
  //   },
  // }
  try {
    dispatch(startLoading())
    const res = await Get(
      `${getApiUrl()}/users/reActiveLink/${id}`,
      user,
    )
    if (res.success) {
      dispatch(stopLoading())
      dispatch({
        type: UPDATE_USER_ACTIVATION_LINK,
        payload: res.data,
      })
      return Promise.resolve(res?.data)
    } else {
      dispatch(stopLoading())
      throw res.error.message
    }
  } catch (err) {
    dispatch(stopLoading())
    return Promise.reject(err)
  }
}
export const updateMFA = (payload) => async (dispatch) => {
  try {
    dispatch(startLoading())

    const res = await Put(
      `${getApiUrl()}/auth/mfaupdate`,
      payload,
    )
    if (res.success) {
      dispatch(stopLoading())
      dispatch({
        type: UPDATE_MFAENABLED,
        payload: res?.data,
      })
    } else {
      dispatch(stopLoading())
      throw res.error.message
    }
  } catch (err) {
    dispatch(stopLoading())
    return Promise.reject(err)
  }
}
export const demography = (section, field) => ({
  type: VIEW_DEMOGRAPHY,
  payload: { section, field },
});
